import { render, staticRenderFns } from "./CreditForm.vue?vue&type=template&id=645b4712&"
import script from "./CreditForm.vue?vue&type=script&lang=js&"
export * from "./CreditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645b4712')) {
      api.createRecord('645b4712', component.options)
    } else {
      api.reload('645b4712', component.options)
    }
    module.hot.accept("./CreditForm.vue?vue&type=template&id=645b4712&", function () {
      api.rerender('645b4712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/CreditForm.vue"
export default component.exports